import { render, staticRenderFns } from "./InformationInitial.vue?vue&type=template&id=9d75c642"
import script from "./InformationInitial.vue?vue&type=script&lang=js"
export * from "./InformationInitial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports